import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function getAnimal(authState: tsWhoAmI, UAI: string) {
  return await phpClient(authState)
    .get<any>(`/json/stuart/animal/getAnimal.php?UAI=${UAI}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getAnimalsInContainer(
  authState: tsWhoAmI,
  container_id: number | string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/sample/getAnimalsInContainer.php?containerID=${container_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const AnimalService = {
  getAnimal,
  getAnimalsInContainer,
}

export default AnimalService
